import { gql, useMutation, useQuery } from "@apollo/client";
import { useContext, useEffect, useState } from "react";

// Components
import { Card, Grid, InputLabel } from "@mui/material";
import Footer from "components/Footer";
import DashboardLayout from "components/LayoutContainers/DashboardLayout";
import DashboardNavbar from "components/Navbars/DashboardNavbar";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

import { MessageManager } from "context";
import { UserContext } from "context/user";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";
import DatosEmpresa from "layouts/manifiestos/DatosEmpresa";
import { OPTIONS } from "layouts/manifiestos/api";

function MiEmpresa() {
  const [empresa, setEmpresa] = useState(null);
  const { handleSnackbar } = useContext(MessageManager);
  const { user } = useContext(UserContext);
  const { data: datosManifiesto, refetch: refreshDatosManifiesto } = useQuery(OPTIONS, {
    skip: !user?.id,
    fetchPolicy: "network-only",
  });

  const [saveEmpresa, { loading: loadingSave }] = useMutation(
    gql`
      mutation saveEmpresa($input: EmpresaInput!) {
        saveEmpresa(input: $input) {
          id
        }
      }
    `
  );
  const { loading, error, data, refetch } = useQuery(
    gql`
      query getEmpresa($idUser: ID!) {
        empresaUser(idUser: $idUser) {
          __typename @skip(if: true)
          id
          razonSocial
          cuit
          email
          codigoAfip
          gerente
          registroCatastral
          habilitacionMunicipalLugar
          habilitacionMunicipalNumero
          actividad
          calleLegal
          cpLegal
          provinciaLegal
          departamentoLegal
          localidadLegal
          telefonoLegal
          faxLegal
          calleReal
          cpReal
          provinciaReal
          departamentoReal
          localidadReal
          telefonoReal
          faxReal
          responsableTecnico {
            id
            nombre
            apellido
            email
            matricula
          }
        }
      }
    `,
    {
      variables: { idUser: user.id },
      skip: !user.id,
      fetchPolicy: "no-cache",
    }
  );

  const handleChangeEmpresa = (event) => {
    const { name, value } = event.target;
    setEmpresa((prev) => ({ ...prev, [name]: value }));
  };
  const handleSaveEmpresa = async (id) => {
    const { actividades, responsableTecnico, ...rest } = empresa;
    try {
      await saveEmpresa({
        variables: {
          input: {
            ...rest,
          },
        },
      });
      handleSnackbar("Guardado correctamente", "success");
    } catch (e) {
      handleSnackbar(e.message || "Error al guardar", "error");
    }
  };
  useEffect(() => {
    if (data) {
      setEmpresa(data.empresaUser);
    }
  }, [data]);
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox py={3}>
        <SoftBox>
          <Card>
            <Grid container spacing={2} p={3}>
              <Grid item xs={12}>
                <SoftBox display="flex" justifyContent="space-between" alignItems="center">
                  <SoftTypography variant="h5" fontWeight="bold">
                    Empresa
                  </SoftTypography>
                </SoftBox>
              </Grid>
              <Grid item xs={6}>
                <InputLabel htmlFor="razonSocial">
                  <SoftTypography component="label" variant="caption" fontWeight="bold">
                    Razón Social
                  </SoftTypography>
                </InputLabel>
                <SoftTypography variant="h6">{empresa?.razonSocial}</SoftTypography>
              </Grid>
              <Grid item xs={6}>
                <InputLabel htmlFor="cuit">
                  <SoftTypography component="label" variant="caption" fontWeight="bold">
                    CUIT
                  </SoftTypography>
                </InputLabel>
                <SoftTypography variant="h6">{empresa?.cuit}</SoftTypography>
              </Grid>
              <Grid item xs={6}>
                <InputLabel htmlFor="email">
                  <SoftTypography component="label" variant="caption" fontWeight="bold">
                    Email
                  </SoftTypography>
                </InputLabel>
                <SoftInput
                  id="email"
                  placeholder="Email"
                  value={empresa?.email || ""}
                  fullWidth
                  name="email"
                  onChange={handleChangeEmpresa}
                />
              </Grid>
              <Grid item xs={6}>
                <InputLabel htmlFor="codigoAfip">
                  <SoftTypography component="label" variant="caption" fontWeight="bold">
                    Código AFIP
                  </SoftTypography>
                </InputLabel>
                <SoftInput
                  id="codigoAfip"
                  placeholder="Código AFIP"
                  value={empresa?.codigoAfip || ""}
                  fullWidth
                  name="codigoAfip"
                  onChange={handleChangeEmpresa}
                />
              </Grid>
              <Grid item xs={6}>
                <InputLabel htmlFor="gerente">
                  <SoftTypography component="label" variant="caption" fontWeight="bold">
                    Gerente
                  </SoftTypography>
                </InputLabel>
                <SoftInput
                  id="gerente"
                  placeholder="Gerente"
                  value={empresa?.gerente || ""}
                  fullWidth
                  name="gerente"
                  onChange={handleChangeEmpresa}
                />
              </Grid>
              <Grid item xs={6}>
                <InputLabel htmlFor="registroCatastral">
                  <SoftTypography component="label" variant="caption" fontWeight="bold">
                    Registro catastral
                  </SoftTypography>
                </InputLabel>
                <SoftInput
                  id="registroCatastral"
                  placeholder="Registro catastral"
                  value={empresa?.registroCatastral || ""}
                  fullWidth
                  name="registroCatastral"
                  onChange={handleChangeEmpresa}
                />
              </Grid>
              <Grid item xs={6}>
                <InputLabel htmlFor="habilitacionMunicipalNumero">
                  <SoftTypography component="label" variant="caption" fontWeight="bold">
                    Número habilitación municipal
                  </SoftTypography>
                </InputLabel>
                <SoftInput
                  id="habilitacionMunicipalNumero"
                  placeholder="Número habilitación municipal"
                  value={empresa?.habilitacionMunicipalNumero || ""}
                  fullWidth
                  name="habilitacionMunicipalNumero"
                  onChange={handleChangeEmpresa}
                />
              </Grid>
              <Grid item xs={6}>
                <InputLabel htmlFor="habilitacionMunicipalLugar">
                  <SoftTypography component="label" variant="caption" fontWeight="bold">
                    Lugar habilitación municipal
                  </SoftTypography>
                </InputLabel>
                <SoftInput
                  id="habilitacionMunicipalLugar"
                  placeholder="Lugar habilitación municipal"
                  value={empresa?.habilitacionMunicipalLugar || ""}
                  fullWidth
                  name="habilitacionMunicipalLugar"
                  onChange={handleChangeEmpresa}
                />
              </Grid>
              {/* Domicilio legal */}
              <Grid item xs={12}>
                <SoftBox display="flex" justifyContent="space-between" alignItems="center">
                  <SoftTypography variant="h5" fontWeight="bold">
                    Domicilio Legal
                  </SoftTypography>
                </SoftBox>
              </Grid>
              <Grid item xs={6}>
                <InputLabel htmlFor="calleLegal">
                  <SoftTypography component="label" variant="caption" fontWeight="bold">
                    Calle
                  </SoftTypography>
                </InputLabel>
                <SoftInput
                  id="calleLegal"
                  placeholder="Calle"
                  value={empresa?.calleLegal || ""}
                  fullWidth
                  name="calleLegal"
                  onChange={handleChangeEmpresa}
                />
              </Grid>
              <Grid item xs={6}>
                <InputLabel htmlFor="localidadLegal">
                  <SoftTypography component="label" variant="caption" fontWeight="bold">
                    Localidad
                  </SoftTypography>
                </InputLabel>
                <SoftInput
                  id="localidadLegal"
                  placeholder="Localidad"
                  value={empresa?.localidadLegal || ""}
                  fullWidth
                  name="localidadLegal"
                  onChange={handleChangeEmpresa}
                />
              </Grid>
              <Grid item xs={4}>
                <InputLabel htmlFor="cpLegal">
                  <SoftTypography component="label" variant="caption" fontWeight="bold">
                    Código postal
                  </SoftTypography>
                </InputLabel>
                <SoftInput
                  id="cpLegal"
                  placeholder="CP"
                  value={empresa?.cpLegal || ""}
                  fullWidth
                  name="cpLegal"
                  onChange={handleChangeEmpresa}
                />
              </Grid>
              <Grid item xs={4}>
                <InputLabel htmlFor="provinciaLegal">
                  <SoftTypography component="label" variant="caption" fontWeight="bold">
                    Provincia
                  </SoftTypography>
                </InputLabel>
                <SoftInput
                  id="provinciaLegal"
                  placeholder="Provincia"
                  value={empresa?.provinciaLegal || ""}
                  fullWidth
                  name="provinciaLegal"
                  onChange={handleChangeEmpresa}
                />
              </Grid>
              <Grid item xs={4}>
                <InputLabel htmlFor="departamentoLegal">
                  <SoftTypography component="label" variant="caption" fontWeight="bold">
                    Departamento
                  </SoftTypography>
                </InputLabel>
                <SoftInput
                  id="departamentoLegal"
                  placeholder="Departamento"
                  value={empresa?.departamentoLegal || ""}
                  fullWidth
                  name="departamentoLegal"
                  onChange={handleChangeEmpresa}
                />
              </Grid>
              <Grid item xs={6}>
                <InputLabel htmlFor="telefonoLegal">
                  <SoftTypography component="label" variant="caption" fontWeight="bold">
                    Teléfono
                  </SoftTypography>
                </InputLabel>
                <SoftInput
                  id="telefonoLegal"
                  placeholder="Teléfono"
                  value={empresa?.telefonoLegal || ""}
                  fullWidth
                  name="telefonoLegal"
                  onChange={handleChangeEmpresa}
                />
              </Grid>
              <Grid item xs={6}>
                <InputLabel htmlFor="faxLegal">
                  <SoftTypography component="label" variant="caption" fontWeight="bold">
                    Fax
                  </SoftTypography>
                </InputLabel>
                <SoftInput
                  id="faxLegal"
                  placeholder="Fax"
                  value={empresa?.faxLegal || ""}
                  fullWidth
                  name="faxLegal"
                  onChange={handleChangeEmpresa}
                />
              </Grid>
              {/* Domicilio Real */}
              <Grid item xs={12}>
                <SoftBox display="flex" justifyContent="space-between" alignItems="center">
                  <SoftTypography variant="h5" fontWeight="bold">
                    Domicilio Real
                  </SoftTypography>
                </SoftBox>
              </Grid>
              <Grid item xs={6}>
                <InputLabel htmlFor="calleReal">
                  <SoftTypography component="label" variant="caption" fontWeight="bold">
                    Calle
                  </SoftTypography>
                </InputLabel>
                <SoftInput
                  id="calleReal"
                  placeholder="Calle"
                  value={empresa?.calleReal || ""}
                  fullWidth
                  name="calleReal"
                  onChange={handleChangeEmpresa}
                />
              </Grid>
              <Grid item xs={6}>
                <InputLabel htmlFor="localidadReal">
                  <SoftTypography component="label" variant="caption" fontWeight="bold">
                    Localidad
                  </SoftTypography>
                </InputLabel>
                <SoftInput
                  id="localidadReal"
                  placeholder="Localidad"
                  value={empresa?.localidadReal || ""}
                  fullWidth
                  name="localidadReal"
                  onChange={handleChangeEmpresa}
                />
              </Grid>
              <Grid item xs={4}>
                <InputLabel htmlFor="cpReal">
                  <SoftTypography component="label" variant="caption" fontWeight="bold">
                    Código postal
                  </SoftTypography>
                </InputLabel>
                <SoftInput
                  id="cpReal"
                  placeholder="CP"
                  value={empresa?.cpReal || ""}
                  fullWidth
                  name="cpReal"
                  onChange={handleChangeEmpresa}
                />
              </Grid>
              <Grid item xs={4}>
                <InputLabel htmlFor="provinciaReal">
                  <SoftTypography component="label" variant="caption" fontWeight="bold">
                    Provincia
                  </SoftTypography>
                </InputLabel>
                <SoftInput
                  id="provinciaReal"
                  placeholder="Provincia"
                  value={empresa?.provinciaReal || ""}
                  fullWidth
                  name="provinciaReal"
                  onChange={handleChangeEmpresa}
                />
              </Grid>
              <Grid item xs={4}>
                <InputLabel htmlFor="departamentoReal">
                  <SoftTypography component="label" variant="caption" fontWeight="bold">
                    Departamento
                  </SoftTypography>
                </InputLabel>
                <SoftInput
                  id="departamentoReal"
                  placeholder="Departamento"
                  value={empresa?.departamentoReal || ""}
                  fullWidth
                  name="departamentoReal"
                  onChange={handleChangeEmpresa}
                />
              </Grid>
              <Grid item xs={6}>
                <InputLabel htmlFor="telefonoReal">
                  <SoftTypography component="label" variant="caption" fontWeight="bold">
                    Teléfono
                  </SoftTypography>
                </InputLabel>
                <SoftInput
                  id="telefonoReal"
                  placeholder="Teléfono"
                  value={empresa?.telefonoReal || ""}
                  fullWidth
                  name="telefonoReal"
                  onChange={handleChangeEmpresa}
                />
              </Grid>
              <Grid item xs={6}>
                <InputLabel htmlFor="faxReal">
                  <SoftTypography component="label" variant="caption" fontWeight="bold">
                    Fax
                  </SoftTypography>
                </InputLabel>
                <SoftInput
                  id="faxReal"
                  placeholder="Fax"
                  value={empresa?.faxReal || ""}
                  fullWidth
                  name="faxReal"
                  onChange={handleChangeEmpresa}
                />
              </Grid>
              {/* RESPONSABLE TÉCNICO */}
              <Grid item xs={12}>
                <SoftBox display="flex" justifyContent="space-between" alignItems="center">
                  <SoftTypography variant="h5" fontWeight="bold">
                    Responsable Técnico
                  </SoftTypography>
                </SoftBox>
              </Grid>
              <Grid item xs={6}>
                <InputLabel htmlFor="nombre">
                  <SoftTypography component="label" variant="caption" fontWeight="bold">
                    Nombre
                  </SoftTypography>
                </InputLabel>
                <SoftTypography variant="h6">
                  {empresa?.responsableTecnico?.nombre
                    ? empresa?.responsableTecnico?.nombre +
                      " " +
                      empresa?.responsableTecnico?.apellido
                    : "No asignado"}
                </SoftTypography>
              </Grid>
              <Grid item xs={6}>
                <InputLabel htmlFor="apellido">
                  <SoftTypography component="label" variant="caption" fontWeight="bold">
                    Matrícula
                  </SoftTypography>
                </InputLabel>
                <SoftTypography variant="h6">
                  {empresa?.responsableTecnico?.matricula}
                </SoftTypography>
              </Grid>
              {/* Guardar */}
            </Grid>
          </Card>
          <Grid display={"flex"} justifyContent="flex-end" py={2}>
            <SoftButton
              variant="gradient"
              color="primary"
              onClick={handleSaveEmpresa}
              disabled={loadingSave || !empresa?.razonSocial || !empresa?.cuit}
            >
              Guardar cambios
            </SoftButton>
          </Grid>
          {datosManifiesto?.manifiestoOpciones && (
            <DatosEmpresa
              options={datosManifiesto.manifiestoOpciones}
              onRefresh={refreshDatosManifiesto}
              report={handleSnackbar}
            />
          )}
        </SoftBox>
      </SoftBox>
      <Footer />
    </DashboardLayout>
  );
}

export default MiEmpresa;
